{
  "forms": {
    "none": "None"
  },
  "create": {
    "modal_title": "Create New Column",
    "column_name_label": "Column name",
    "add_column_button": "Add Column",
    "add_column_aria_label": "Add Column",
    "validation": {
      "name_required": "Please come up with a name for the new field",
      "type_required": "Please select a type for the new field",
      "options_required": "Please tell us what are the options",
      "currency_required": "Please select a currency"
    },
    "yes_no_options": {
      "yes": "Yes",
      "no": "No"
    }
  },
  "value_type": {
    "label": "Value Type"
  },
  "value_types": {
    "date": "Date",
    "multi_select": "Multi Select",
    "select": "Select",
    "number": "Number",
    "rich_text": "Rich Text",
    "text": "Text",
    "employee": "Employee",
    "employees": "Employees",
    "contacts": "Contacts",
    "companies": "Companies",
    "currency": "Currency",
    "yes_no_option": "Yes/No Option",
    "countries": "Countries",
    "date_time": "Date Time"
  },
  "remove": {
    "confirmation_title": "Are you sure you want to remove this field?",
    "aria_label": "remove custom field"
  },
  "options": {
    "modal_title": "New Options",
    "add_button": "Option",
    "value_label": "Option Value",
    "remove_aria_label": "remove option",
    "validation": {
      "values_required": "Please enter the new values"
    },
    "update": {
      "modal_title": "Update Option Value",
      "value_label": "Option value",
      "validation": {
        "value_required": "Please enter a value",
        "colour_required": "Please select a colour"
      }
    },
    "new_chip_label": "New Options"
  },
  "schema": {
    "update_aria_label": "update custom field schema",
    "edit_title": "Edit Field",
    "field_name_label": "Field Name",
    "campaigns_using_filter_one": "{{campaignNames}} is using this as a filter. Please remove the filters on the campaign before updating the column.",
    "campaigns_using_filter_other": "{{campaignNames}} are using this as a filter. Please remove the filters on the campaigns before updating the column."
  },
  "accessibility": {
    "info_tooltip": "Info"
  }
}
